import React from 'react';
import classNames from 'classnames/bind';

import styles from './DimmedPopup.module.scss';

const cx = classNames.bind(styles);

interface DimmedProps {
  children: React.ReactNode;
  className?: string;
}

export const DimmedHeader: React.FC<DimmedProps> = ({ className, children }) => (
  <div className={cx('DimmedHeader', className)}>{children}</div>
);

export const DimmedContent: React.FC<DimmedProps> = ({ className, children }) => (
  <div className={cx('DimmedContent', className)}>
    <div className={cx('inner')}>{children}</div>
  </div>
);

export const DimmedFooter: React.FC<DimmedProps> = ({ className, children }) => (
  <div className={cx('DimmedFooter', className)} data-dimmed-footer>
    {children}
  </div>
);

const DimmedPopup: React.FC<DimmedProps> = ({ className, children }) => {
  return (
    <div className={cx('DimmedPopup', className)} role="dialog" aria-modal="true">
      <div className={cx('inner')}>
        <div className={cx('component')}>{children}</div>
      </div>
    </div>
  );
};

export default DimmedPopup;
